/* RESPONSIBLE TEAM: team-self-serve */

import Service, { inject as service } from '@ember/service';
import type ModalService from 'embercom/services/modal-service';

export default class TrialExtensionModalService extends Service {
  @service declare modalService: ModalService;

  openModal(options?: { onClose?: () => void }) {
    this.modalService.openModal(
      'react/trial-extension-dialog',
      {
        isOpen: true,
        onClose: () => {
          this.modalService.closeModal();
          options?.onClose?.();
        },
      },
      {
        showIntercomWidget: true,
      },
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    trialExtensionModalService: TrialExtensionModalService;
    'trial-extension-modal-service': TrialExtensionModalService;
  }
}
